import { render, staticRenderFns } from "./SalesProfitNumberDisplayer.vue?vue&type=template&id=61bd5ebf"
import script from "./SalesProfitNumberDisplayer.vue?vue&type=script&lang=ts"
export * from "./SalesProfitNumberDisplayer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports